import { render } from "./AdminParentSalons.vue?vue&type=template&id=d33f5142"
import script from "./AdminParentSalons.vue?vue&type=script&lang=js"
export * from "./AdminParentSalons.vue?vue&type=script&lang=js"

import "./AdminParentSalons.vue?vue&type=style&index=0&id=d33f5142&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__